/* Coastal Slate & Brass — fitment bar drives the Cart Designator variant.

   The shopper's cart is chosen once in the fitment bar. Rather than recording
   that as a text note on the line item, it selects the matching product
   variant, so the choice travels as a real variant — visible in the cart, at
   checkout, on the order, the packing slip and the confirmation email, and
   carried by the SKU (G1-FS1-TXT-…), which is where the codes live.

   The mapping lives in the fitment bar's settings, since which designator suits
   which cart is business knowledge. A cart with no mapping simply leaves the
   picker untouched for the shopper to set themselves.

   Deliberately non-destructive: it only preselects while the shopper has not
   yet touched the picker. Once they choose for themselves, their choice wins. */
(function () {
  var CODE_KEY = 'tco:designator';
  var touched = false;

  function storedCode() {
    try {
      return localStorage.getItem(CODE_KEY) || '';
    } catch (e) {
      return '';
    }
  }

  function inputs() {
    return document.querySelectorAll(
      '.product-form__input input[type="radio"], .product-form__input select option'
    );
  }

  /* The shopper-facing option is the cart name alone ("E-Z-GO TXT (1995+) /
     RXV (2008+)") — the CPR/DRV/TXT codes live only in the SKU — so the mapping
     stores the full designator label and this compares the whole value. */
  function matches(value, target) {
    if (!value || !target) return false;
    return value.trim().toUpperCase() === target.trim().toUpperCase();
  }

  function apply() {
    if (touched) return;
    var target = storedCode();
    if (!target) return;

    var list = inputs();
    for (var i = 0; i < list.length; i++) {
      var el = list[i];
      if (!matches(el.value, target)) continue;

      if (el.tagName === 'OPTION') {
        var sel = el.closest('select');
        if (sel && sel.value !== el.value) {
          sel.value = el.value;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        }
      } else if (!el.checked) {
        var label = document.querySelector('label[for="' + el.id + '"]');
        (label || el).click();
      }
      return;
    }
  }

  // Once the shopper picks for themselves, stop overriding them.
  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('.product-form__input')) touched = true;
  });

  document.addEventListener('DOMContentLoaded', apply);
  document.addEventListener('shopify:section:load', apply);
  document.addEventListener('tco:designator', function () { touched = false; apply(); });
  if (document.readyState !== 'loading') apply();
})();
